
import React, { useEffect, useState, useContext } from "react";
import { isLibraryUser, isInternal, isAdvancedOrLibraryUser, isNumeric, checkAvailability } from "../helpers.mjs";
import { PubSub } from "../weave/helpers.mjs";
import { SearchContext } from "../components/SearchContext.js";
import { openModal } from "../modal.js";
import { fetchJson } from "../fetch.js";

// Keeps leading icons at the start of option text inside dir="rtl" selects
const LEFT_TO_RIGHT_MARK = String.fromCharCode(0x200E);

const AddToBasket = ({ hit, product, isBookPack=false }) => {
    const { extraData, baskets, activeBasketId, bookshelves, sharedBookshelves, basketSelect, bookshelfSelect, setBasketSelect, setBookshelfSelect, updateInBookshelfData, updateInSharedBookshelfData, updateInWishlistData } = useContext(SearchContext);

    const [justAdded, setJustAdded] = useState(false);

    useEffect(() => {
        if (isLibraryUser()) {
            return;
        }

        PubSub.sub("basketItemUpdate", (prid, bsId, quantity, additive) => {
            if (prid == product && additive == true) {
                setJustAdded(true);
                setTimeout(function () {
                    setJustAdded(false);
                }, 4000);
            }
        });
    }, []);

    const hasData = extraData !== null && extraData[product];
    let productPrice = hasData ? extraData[product].price : 0;

    const basketData = hasData ? extraData[product].basketData : null;
    const bookshelfData = hasData ? extraData[product].bookshelfData : null;
    const sharedBookshelfData = hasData ? extraData[product].sharedBookshelfData : null;
    const inWishlist = hasData ? extraData[product].inWishlist : false;

    const buildBaskets = baskets => {
        let basketsArray = [];

        if (baskets) {
            for (let b in baskets) {
                if (baskets[b].type != "Furniture" && baskets[b].type != "wishlist") {
                    basketsArray.push(baskets[b]);
                }
            }
        }

        return basketsArray;
    }

    const basketsArray = buildBaskets(baskets);
    const isavailable = checkAvailability(hit, productPrice);

    const selectedBasketId = basketSelect[product];
    const selectedBookshelfId = bookshelfSelect[product];

    if (!hasData || !isNumeric(selectedBasketId) || !selectedBookshelfId) {
        return (
            <div className="addToBasketContainer">
                <span className="atbButton skeletonItemWithPulse" />
                {isAdvancedOrLibraryUser() && <span className="atbButton bookshelf skeletonItemWithPulse">&nbsp;</span>}
                {!isAdvancedOrLibraryUser() && <span className="wishlistText skeletonItemWithPulse">&nbsp;</span>}
            </div>
        )
    }

    const inSelectedBasket = selectedBasketId && basketData && basketData.find(b => b.bsId == selectedBasketId) ? basketData.find(b => b.bsId == selectedBasketId).biQty : 0;
    const selectedBasketName = (baskets && baskets[selectedBasketId]) ? baskets[selectedBasketId].name : "basket";

    let buttonText = "ADD TO BASKET";
    if (justAdded) {
        buttonText = "ADDED";
    } else if (!isInternal() && !isavailable) {
        buttonText = "Not available to order";
    } else if (isLibraryUser()) {
        buttonText = inSelectedBasket > 0 ? `${inSelectedBasket} UNIT${inSelectedBasket > 1 ? "S" : ""}` : "ADD TO BASKET";
    } else if (inSelectedBasket > 0) {
        if (isBookPack) {
            buttonText = "ALREADY IN BASKET";
        } else {
            buttonText = "ADD MORE";
        }
    }

    const inSelectedBookshelf = selectedBookshelfId && bookshelfData && bookshelfData.some(bk => bk.bksId == selectedBookshelfId) ? true : false;
    const selectedBookshelfName = selectedBookshelfId && bookshelves && bookshelves.find(bk => bk.bksId == selectedBookshelfId) ? bookshelves.find(bk => bk.bksId == selectedBookshelfId).bksName : "";

    const addToBookshelf = e => {
        if (inSelectedBookshelf) {
            return; // already in bookshelf
        }

        if (selectedBookshelfId == "new") {
            PubSub.pub("wantAddToBookshelf", product);
            openModal("addBookshelf");
            return;
        }

        fetchJson("/bookshelves/addProduct/" + selectedBookshelfId + "/" + product)
            .then(() => {
                updateInBookshelfData(product, selectedBookshelfId, true);
            });
    }

    const removeFromBookshelf = e => {
        fetchJson("/bookshelves/removeProduct/" + selectedBookshelfId + "/" + product).then(() => {
            updateInBookshelfData(product, selectedBookshelfId, false);
        });
    }

    const addToSharedBookshelf = bksId => {
        fetchJson("/bookshelves/addSharedProduct/" + bksId + "/" + product)
            .then(() => {
                updateInSharedBookshelfData(product, bksId, true);
            });
    }

    const removeFromSharedBookshelf = bksId => {
        fetchJson("/bookshelves/removeSharedProduct/" + bksId + "/" + product)
            .then(() => {
                updateInSharedBookshelfData(product, bksId, false);
            });
    }

    return (
        <div key={`addToBasketContainer${product}`} className="addToBasketContainer">
            {<div className={"addButtonContainer" + (!isavailable ? (!isInternal() ? " disabled" : " addOutOfStock") : "") + (isBookPack && inSelectedBasket > 0 ? " disabled" : "")}>
                <div prid={product} className={"addToBasket basketButton" + (justAdded ? " ADDED" : "")}><p className="wishlistText" title={`${inSelectedBasket} cop${inSelectedBasket != 1 ? "ies" : "y"} in ${selectedBasketName}`}>{buttonText}</p></div>
                {inSelectedBasket > 0 && <div className="removeFromBasket basketButton" data-prid={product} type="button"><span className="fa fa-trash"></span></div>}
                {(inSelectedBasket > 0 || isavailable || (!isavailable && isInternal())) && <div className="basketSelectWrapper addToBasketSelectWrapper">
                    <select className="addToBasketSelect" dir="rtl" name="basketToAddTo" value={basketSelect[product]} onChange={e => {
                        var bstmp = basketSelect;
                        bstmp[product] = e.target.value;
                        setBasketSelect({ ...basketSelect, product: e.target.value });
                    }}>
                        {basketsArray.map((bs,i) => <option key={`basketoption${bs}${i}`} value={bs.id}>{bs.name}</option>)}
                        {(basketsArray.length === 0 || !activeBasketId) && <option value={0}>Basket</option>}
                    </select>
                </div>}
            </div>}
            {isAdvancedOrLibraryUser() && <div className="addButtonContainer bookshelf">
                <div data-prid={product} onClick={addToBookshelf} title="Click to add this product to the selected bookshelf" className={"addToBasket basketButton bookshelfButton" + (inSelectedBookshelf ? " added" : "")}><p className="wishlistText">{inSelectedBookshelf ? selectedBookshelfName : "ADD TO BOOKSHELF"}</p></div>
                {inSelectedBookshelf && <div className="removeFromBookshelf basketButton bookshelfButton" data-prid={product} type="button" onClick={removeFromBookshelf}><span className="fa fa-trash"></span></div>}
                <div className="addToBasketSelectWrapper">
                    <select className="addToBasketSelect" dir="rtl" name="bookshelfToAddTo" value={selectedBookshelfId} onChange={e => {
                        const val = e.target.value;
                        if (typeof val === "string" && val.startsWith("shared-")) {
                            const sharedBksId = val.replace("shared-", "");
                            const inShared = sharedBookshelfData && sharedBookshelfData.some(d => d.bksId == sharedBksId);
                            inShared ? removeFromSharedBookshelf(sharedBksId) : addToSharedBookshelf(sharedBksId);
                            return;
                        }
                        if (val == "new") {
                            PubSub.pub("wantAddToBookshelf", product);
                            openModal("addBookshelf");
                            return;
                        }
                        // var bktmp = bookshelfSelect;
                        // bktmp[product] = e.target.value;
                        setBookshelfSelect({ ...bookshelfSelect, [product]: val });
                    }}>
                        {bookshelves && bookshelves.map((b, i) => {
                            var inBookshelf = 0;
                            if (bookshelfData) {
                                inBookshelf = bookshelfData.some(d => d.bksId == b.bksId) ? 1 : 0
                            }
                            if(inBookshelf) {
                                return <option key={i} data-inbookshelf={inBookshelf} value={b.bksId}>{b.bksName} (ADDED)</option>
                            } else {
                                return <option key={i} data-inbookshelf={inBookshelf} value={b.bksId}>{b.bksName}</option>
                            }
                        })}
                        {sharedBookshelves && sharedBookshelves.map(sb => {
                            const inShared = sharedBookshelfData && sharedBookshelfData.some(d => d.bksId == sb.bksId);
                            return (
                                <option key={`sharedBookshelf${sb.bksId}`} value={`shared-${sb.bksId}`}>
                                    {`${LEFT_TO_RIGHT_MARK}👥 ${inShared ? "Remove from" : "Add to"} ${sb.bksName}`}
                                </option>
                            );
                        })}
                        <option value="new">New bookshelf</option>
                    </select>
                </div>
            </div>}
            {!isAdvancedOrLibraryUser() && <div data-prid={product} className={`homeWishlistButton ${inWishlist ? "removeFromWishList" : "addToWishList"} basketButton`} onClick={() => {
                updateInWishlistData(product, !inWishlist);
                $.ajax({
                    method: 'POST',
                    cache: false,
                    url: '/widgets/ajax/ajax.basket.actions.php',
                    data: {
                        action: inWishlist ? 'removeFromWishList' : 'addToWishList',
                        prid: product,
                    }
                });
            }}>
                <p className="wishlistText">{inWishlist ? "Remove from wishlist" : "Add to wishlist"}</p>
            </div>}
        </div>
    )
}

export default AddToBasket;